import { render, staticRenderFns } from "./NewMigration.vue?vue&type=template&id=1ad63312"
import script from "./NewMigration.vue?vue&type=script&lang=js"
export * from "./NewMigration.vue?vue&type=script&lang=js"
import style0 from "./NewMigration.vue?vue&type=style&index=0&id=1ad63312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports